import { exploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { useExploreContext } from '@components/Contexts/ExploreContext';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import { useBi } from '@components/Hooks/useBi';
import { getWixLoginUrl } from '@utils/urlUtils';

export const useBriefPromoCard = () => {
  const { t } = useTranslation();
  const {
    state: { language, origin, entry },
  } = useExploreContext();
  const { userDetails, host } = useHeaderContext();
  const BRIEF_URL = `${host}/marketplace/brief-auto-match?entry=explore&origin=results-page-top`;
  const { sessionId } = useBiSessionContext();
  const logger = useBi();

  const matchURL =
    userDetails == null
      ? `${getWixLoginUrl(language)}&redirectTo=${encodeURIComponent(
          BRIEF_URL,
        )}`
      : BRIEF_URL;

  const handleCtaClick = () => {
    logger.report(
      exploreResultsPageGenericClick({
        clickType: 'Get Matched',
        sessionId,
        origin,
        entry,
        exploreVersion: 'V2',
      }),
    );
  };

  return { t, matchURL, handleCtaClick };
};
